"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LimitedMenuList = exports.Placeholder = exports.ValueContainer = exports.SingleValueAvatarWithDescription = exports.SingleValueAvatar = exports.InputWithPaste = exports.createMultiValueForSingularOption = exports.onSelectedChangeWithSingularList = exports.FADropdownIndicator = exports.MultipleSelectControl = exports.NameDescIconOption = exports.NameDescAccountTypeOption = exports.FASingleSelect = exports.SingleValue = exports.MenuList = exports.formatGroupLabel = exports.NameDescOption = exports.Option = exports.Control = exports.NoAutoCompleteInput = exports.DropdownIndicator = void 0;
const react_1 = __importDefault(require("react"));
const react_select_1 = require("react-select");
const classnames_1 = __importDefault(require("classnames"));
const get_1 = __importDefault(require("lodash/get"));
const has_1 = __importDefault(require("lodash/has"));
const head_1 = __importDefault(require("lodash/head"));
const map_1 = __importDefault(require("lodash/map"));
const sumBy_1 = __importDefault(require("lodash/sumBy"));
const dropdown_arrow_1 = __importDefault(require("../icons/dropdown-arrow/dropdown-arrow"));
const user_avatar_1 = __importStar(require("../user-avatar/user-avatar"));
const isGrouped = (opts) => (0, has_1.default)((0, head_1.default)(opts), 'options');
const SearchMessage = ({ searchMessage, itemsLength, inputValue }) => (inputValue ? (react_1.default.createElement("div", { className: "search-message" }, `Please refine your search, more than ${itemsLength < 100 ? itemsLength : Math.floor(itemsLength / 100) * 100} results`)) : (react_1.default.createElement("div", { className: "search-message" }, searchMessage || 'Enter 2 or more characters for more results')));
const LimitedMenuList = (props) => {
    const { selectProps, children, options } = props;
    const { maxItemsToRender = 400, inputValue, searchMessage } = selectProps;
    const isGroupedOptions = isGrouped(options);
    const shouldShowItems = (!children.length || children.length < maxItemsToRender);
    if (!isGroupedOptions && shouldShowItems) {
        return children;
    }
    if (isGroupedOptions) {
        const totalGroupsLength = (0, sumBy_1.default)(children, ((x) => x.props.options.length));
        const shouldShowGroupItems = (totalGroupsLength < maxItemsToRender);
        if (shouldShowGroupItems) {
            return children;
        }
        return (react_1.default.createElement(react_1.default.Fragment, null,
            children.map((group) => ((0, get_1.default)(group, 'props.data.fixed') ? group : null)),
            react_1.default.createElement(SearchMessage, { inputValue: inputValue, itemsLength: totalGroupsLength, searchMessage: searchMessage })));
    }
    return react_1.default.createElement(SearchMessage, { inputValue: inputValue, itemsLength: children.length, searchMessage: searchMessage });
};
exports.LimitedMenuList = LimitedMenuList;
const MenuList = (props) => (react_1.default.createElement(react_select_1.components.MenuList, { ...props },
    react_1.default.createElement(LimitedMenuList, { ...props })));
exports.MenuList = MenuList;
const DropdownIndicator = (props) => (react_select_1.components.DropdownIndicator && (react_1.default.createElement(react_select_1.components.DropdownIndicator, { ...props },
    react_1.default.createElement(dropdown_arrow_1.default, { open: props?.selectProps.menuIsOpen, focused: props?.isFocused }))));
exports.DropdownIndicator = DropdownIndicator;
const NoAutoCompleteInput = (props) => (react_select_1.components.Input && (react_1.default.createElement(react_select_1.components.Input, { ...props, autoComplete: "chrome-off" })));
exports.NoAutoCompleteInput = NoAutoCompleteInput;
const FADropdownIndicator = ({ open, selectProps: { menuIsOpen = open } = {} }) => react_1.default.createElement("i", { className: `fa ${menuIsOpen ? 'fa-angle-up' : 'fa-angle-down'}` });
exports.FADropdownIndicator = FADropdownIndicator;
const SingleValue = (props) => (react_select_1.components.SingleValue && (react_1.default.createElement(react_select_1.components.SingleValue, { ...props })));
exports.SingleValue = SingleValue;
const Control = (props) => {
    const { selectProps } = props;
    return (react_1.default.createElement("div", { className: `control-wrapper ${(!selectProps.isValid ? 'invalid' : '')}` },
        react_1.default.createElement(react_select_1.components.Control, { ...props })));
};
exports.Control = Control;
const FASingleSelect = (props) => {
    const { selectProps: { value } } = props;
    return (react_1.default.createElement(react_select_1.components.SingleValue, { ...props },
        react_1.default.createElement("div", { className: "selected-title-wrapper" },
            react_1.default.createElement("div", { className: "selected-title-label" }, (0, get_1.default)(value, 'label')),
            react_1.default.createElement("i", { className: "fa fa-angle-down" }))));
};
exports.FASingleSelect = FASingleSelect;
const MultipleSelectControl = (props) => {
    const { selectProps: { value, title } } = props;
    return (react_1.default.createElement(react_select_1.components.SingleValue, { ...props },
        react_1.default.createElement("div", { className: "selected-title-wrapper" },
            value.length <= 1 ? (react_1.default.createElement("div", null, (0, get_1.default)((0, head_1.default)(value), 'label'))) : (react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement("div", { className: "selected-size" }, value.length),
                react_1.default.createElement("div", null, title || 'Items'))),
            react_1.default.createElement("i", { className: "fa fa-angle-down" }))));
};
exports.MultipleSelectControl = MultipleSelectControl;
const Option = (props) => {
    const { innerProps: { ref, onMouseMove, onMouseOver, ...restInnerProps }, isDisabled, customClass = '', isFocused, children, data, } = props;
    return (react_1.default.createElement("div", { className: (0, classnames_1.default)('dropdown-option-react', customClass, { 'is-focused': isFocused && !isDisabled, disabled: isDisabled }), ...restInnerProps, ref: ref }, children || react_1.default.createElement("div", null,
        react_1.default.createElement("div", { className: "title" }, data.label))));
};
exports.Option = Option;
const NameDescOption = (props) => {
    const { data: { label, desc, className } } = props;
    return (react_1.default.createElement(Option, { ...props },
        react_1.default.createElement("div", { className: className || '' },
            react_1.default.createElement("div", { className: "title" }, label),
            react_1.default.createElement("div", { className: "description" }, desc))));
};
exports.NameDescOption = NameDescOption;
const NameDescIconOption = (props) => {
    const { data: { label, desc, className, type } } = props;
    return (react_1.default.createElement(Option, { ...props },
        react_1.default.createElement("div", { className: className || '' },
            type && (type === 'ACCOUNT' ? react_1.default.createElement("i", { className: "fa fa-suitcase" }) : react_1.default.createElement("i", { className: "fa fa-user" })),
            react_1.default.createElement("span", { className: "title" }, label),
            react_1.default.createElement("div", { className: "description" }, desc))));
};
exports.NameDescIconOption = NameDescIconOption;
const NameDescAccountTypeOption = (props) => {
    const { data: { label, desc, accountTypes, className } } = props;
    return (react_1.default.createElement(Option, { ...props },
        react_1.default.createElement("div", { className: "form-option" },
            react_1.default.createElement("div", { className: (0, classnames_1.default)('title-holder', className) },
                react_1.default.createElement("div", { className: "title" }, label),
                react_1.default.createElement("div", { className: "description" }, desc)),
            react_1.default.createElement("div", { className: "account-types" }, (0, map_1.default)(accountTypes, (accountType) => (react_1.default.createElement("div", { key: accountType, className: "type" }, accountType)))))));
};
exports.NameDescAccountTypeOption = NameDescAccountTypeOption;
const formatGroupLabel = (data) => (react_1.default.createElement("div", { className: "group-label" },
    react_1.default.createElement("span", null, data.label),
    react_1.default.createElement("span", { className: "group-badge" }, ` ${data.options.length}`)));
exports.formatGroupLabel = formatGroupLabel;
const onSelectedChangeWithSingularList = (newSelected, singularOptions) => {
    const newlySelected = (0, head_1.default)(newSelected.filter((s) => !s.selected));
    let newSelectedValues = [];
    if (newlySelected && (singularOptions.find((opt) => opt.value === newlySelected.value))) {
        newSelectedValues = [newlySelected];
    }
    else {
        newSelectedValues = newSelected.filter((x) => !singularOptions.find((opt) => opt.value === x.value));
    }
    return newSelectedValues;
};
exports.onSelectedChangeWithSingularList = onSelectedChangeWithSingularList;
const createMultiValueForSingularOption = (singularOptions) => (props) => {
    const defaultOption = singularOptions.find((opt) => opt.value === props?.data.value);
    if (defaultOption) {
        return react_1.default.createElement("div", { className: "default-option" }, defaultOption.label);
    }
    return react_1.default.createElement(react_select_1.components.MultiValue, { ...props });
};
exports.createMultiValueForSingularOption = createMultiValueForSingularOption;
const InputWithPaste = (props) => {
    const { selectProps } = props;
    return react_1.default.createElement(react_select_1.components.Input, { ...props, onPaste: selectProps.onPaste });
};
exports.InputWithPaste = InputWithPaste;
const SingleValueAvatar = ({ data, showDescription, usersMap, poolsList }) => (react_1.default.createElement("div", { className: "option-container" },
    react_1.default.createElement("div", { className: "option-wrapper" }, data.value && data.label ? (react_1.default.createElement(react_1.default.Fragment, null,
        !data.isPool && react_1.default.createElement(user_avatar_1.default, { usersMap: usersMap, fullName: data.label, email: data.value, avatarId: data.avatarId, imgUrl: data.img, size: 18 }),
        data.isPool && react_1.default.createElement(user_avatar_1.PoolComp, { poolsList: poolsList, poolId: data.value, fullName: data.label }),
        react_1.default.createElement("div", { className: "option-name-wrapper" },
            react_1.default.createElement("span", { className: "option-text" }, data.label),
            showDescription && data.desc ? react_1.default.createElement("span", { className: "option-text description" }, data.desc) : ''))) : '')));
exports.SingleValueAvatar = SingleValueAvatar;
const SingleValueAvatarWithDescription = (props) => react_1.default.createElement(SingleValueAvatar, { ...props, showDescription: true });
exports.SingleValueAvatarWithDescription = SingleValueAvatarWithDescription;
const ValueContainer = (props) => react_1.default.createElement(react_select_1.components.ValueContainer, { ...props });
exports.ValueContainer = ValueContainer;
const Placeholder = (props) => react_1.default.createElement(react_select_1.components.Placeholder, { ...props });
exports.Placeholder = Placeholder;
//# sourceMappingURL=select-components.js.map